import * as React from "react";

function SvgVectorEditor(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 0H3a3 3 0 00-3 3v18a3 3 0 003 3h18a3 3 0 003-3V3a3 3 0 00-3-3zM1.5 3A1.5 1.5 0 013 1.5h18A1.5 1.5 0 0122.5 3v18a1.5 1.5 0 01-1.5 1.5H3A1.5 1.5 0 011.5 21V3zm9.71.75h1.908v.436l-1.224 1.278h1.269v.469h-2.071V5.48l1.21-1.264H11.21V3.75zm7.415 14.864h.75l.44.738.44-.738H21l-.849 1.269v.914h-.676v-.914l-.85-1.268zm-14.814 0h-.743l.685 1.046L3 20.797h.753l.432-.701.43.701h.758l-.743-1.125.68-1.058h-.736l-.375.672-.388-.672zm9.744-9.632l-1.524-1.906-1.525 1.906h.762v4.463l-4.1 2.87-.437-.624-.686 2.342 2.435.156-.437-.625 3.982-2.788 3.983 2.788-.438.625 2.436-.156-.687-2.342-.437.625-4.089-2.864v-4.47h.762z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgVectorEditor;
